import React, { useEffect, useState, useMemo,useRef } from 'react';

import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import { useMap } from 'react-leaflet';
import './CustomMyIconControl.css'
import L from 'leaflet';

const CustomMyIconControl = ({ backClick, showDrowAreaButtonClick }) => {
  const map = useMap();
  const panelButtonRef = useRef(null);
  useEffect(() => {
    if (panelButtonRef.current) {
      // جلوگیری از انتشار کلیک به نقشه
      L.DomEvent.disableClickPropagation(panelButtonRef.current);
    }
  }, []);
  return (
    <div className="custom-control2  " ref={panelButtonRef}>
      <button onClick={(e) => { backClick(e); }}>
       🎛️
        پنل امکانات
      </button>
      <button onClick={(e) => { showDrowAreaButtonClick(e); }}>
       📐 
        محدوده
      </button>
       
      <Link
        to="https://noroncar.ir"
        className='text-decoration-none  '>
        🌍
        سامانه نورون
      </Link>
    </div >
  );
};

export default CustomMyIconControl;
